import React, { useState, useEffect } from 'react';
import { ArrowUpIcon } from './IconComponents';
import Tooltip from './Tooltip';

const ScrollToTopButton: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div className={`fixed bottom-5 right-5 transition-all duration-300 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90 pointer-events-none'
        }`}>
            <Tooltip text="Scroll to Top">
                <button
                    type="button"
                    onClick={scrollToTop}
                    className="p-3 rounded-full bg-brand-blue/80 dark:bg-brand-accent-dark/90 text-white shadow-lg hover:bg-brand-blue dark:hover:bg-brand-accent-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue dark:focus:ring-brand-accent-dark"
                    aria-label="Go to top"
                    tabIndex={isVisible ? 0 : -1}
                >
                    <ArrowUpIcon className="w-6 h-6" strokeWidth={2} />
                </button>
            </Tooltip>
        </div>
    );
};

export default ScrollToTopButton;